// Strips any character that isn't a digit, space, +, -, (, ) from phone input
export const filterPhone = (v) => v.replace(/[^\d\s+\-()]/g, '');

// Returns true only if the string looks like a valid email
export const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim());
